import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const BitbucketDataCenterDetailsPage = VcsDetailsPage;

export default BitbucketDataCenterDetailsPage;
